import React from 'react';
import Hero from '../components/Hero/Hero';
import Projects from '../components/Projects';
import GamesLink from '../components/GamesLink';
import Services from '../components/Services';
import ContactCTA from '../components/ContactCTA';
import './Home.css?module';

const Home: React.FC = () => {
  return (
    <div className="home">
      <Hero />
      <Projects />
      <GamesLink />
      <Services />
      <ContactCTA />
    </div>
  );
};

export default Home;
